import { useId } from 'react';

/** A striped retro sunset sun (decoration only). */
export function VaporSun({ className = 'vapor-sun' }: { className?: string }) {
  const id = useId();
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-sun`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffd36e" />
          <stop offset="0.55" stopColor="#ff6ad5" />
          <stop offset="1" stopColor="#c03ce0" />
        </linearGradient>
        {/* Gaps that widen toward the bottom, like the sun sinking behind blinds. */}
        <mask id={`${id}-stripes`}>
          <rect width="100" height="100" fill="white" />
          <rect y="58" width="100" height="2.5" fill="black" />
          <rect y="66" width="100" height="3.5" fill="black" />
          <rect y="75" width="100" height="5" fill="black" />
          <rect y="86" width="100" height="7" fill="black" />
        </mask>
      </defs>
      <circle cx="50" cy="50" r="46" fill={`url(#${id}-sun)`} mask={`url(#${id}-stripes)`} />
    </svg>
  );
}
